import type { ReactNode } from 'react';
import { Tab, Tabs, type TabsProps } from '@mui/material';

export type HFTabItem = { value: string; label: ReactNode; disabled?: boolean };

export type HFTabsProps = Omit<TabsProps, 'value' | 'onChange'> & {
  value: string;
  items: HFTabItem[];
  onChange?: (value: string) => void;
};

export function HFTabs({ value, items, onChange, ...props }: HFTabsProps) {
  return (
    <Tabs value={value} {...props} onChange={(_, next) => onChange?.(String(next))}>
      {items.map((item) => (
        <Tab key={item.value} value={item.value} label={item.label} disabled={item.disabled} />
      ))}
    </Tabs>
  );
}
